import { HarmonyProductGroup } from "../types/thirdParty/harmony/HarmonyProductGroup";
import { ReduxDispatch } from "../types/redux/ReduxDispatch";
import { fetchCartInfo } from "./CartActions";
import { EnrollmentPackageId } from "../types/api/primaryKeys/PrimaryKey";
import { updateElectionResults, updateAllElections, fetchHarmonyEnrollmentTokenForPackage } from "../apiCalls/Harmony/harmonyApiCalls";
import { Package } from "../types/api/enrollmentPackages/Package";
import { Nullable } from "../types/custom/Nullable";

export enum HarmonyActionType {
    ON_SUCCESS = "ON_HARMONY_SUCCESS",
    ON_WIDGET = "ON_HARMONY_WIDGET",
    AFTER_INIT = "AFTER_HARMONY_INIT",
    ON_INIT = 'ON_HARMONY_INIT',
    FETCHING = 'FETCHING_HARMONY_TOKEN'
}

export type HarmonyAction =
    | ReturnType<typeof onSuccessCallBack>
    | ReturnType<typeof onWidgetRender>
    | ReturnType<typeof afterHarmonyInit>
    | ReturnType<typeof onHarmonyInit>
    | ReturnType<typeof fetchingToken>;

export function onSuccessCallBack() {
    return {
        type: HarmonyActionType.ON_SUCCESS
    } as const;
}

export function onWidgetRender(harmonyProductGroup: HarmonyProductGroup) {
    return {
        type: HarmonyActionType.ON_WIDGET,
        payload: harmonyProductGroup as HarmonyProductGroup
    } as const;
}

export function fetchUpdateHarmonyProgress(packageId: EnrollmentPackageId, harmonyProductGroup: HarmonyProductGroup, enrollmentToken: string) {
    return async (dispatch: ReduxDispatch) => {
        try {
            await updateElectionResults(packageId, enrollmentToken, harmonyProductGroup);
            await fetchCartInfo(packageId)(dispatch);
            dispatch(onSuccessCallBack());
        } catch {
            //TODO: this is when election results fails to update during navigation, i do not think a hardstop is needed
        }
    };
}

export function updateAllHarmony(packageId: EnrollmentPackageId, enrollmentToken: Nullable<string>, activePackage: Package, currentStep: number) {
    return async (dispatch: ReduxDispatch) => {
        //placeholder to hold all harmony product groups related to package
        const harmonyProductGroups = [];
        const steps = activePackage.steps ?? [];

        for (const step of steps) {
            //look up to the current step the user is at, no need to look thru the whole loop
            //e.g. there are 12 total steps but user only went through 4 steps, dont look further than 4
            if (step.number > currentStep) {
                break;
            }
            if (step.harmonyProductGroup) {
                harmonyProductGroups.push(step.harmonyProductGroup);
            }
        }
        //check if harmonyproductgroup has been included if at all
        if (harmonyProductGroups.length) {
            dispatch(afterHarmonyInit());
            if (enrollmentToken) { //enrollment token was already fetched before
                try {
                    await updateAllElections(packageId, enrollmentToken, harmonyProductGroups);
                    await fetchCartInfo(packageId)(dispatch);
                } catch {
                    dispatch(onHarmonyInit(null));
                }
            } else {
                try {
                    dispatch(fetchingToken());
                    const tokenResult = await fetchHarmonyEnrollmentTokenForPackage(packageId);
                    await updateAllElections(packageId, tokenResult.enrollmentTokenId, harmonyProductGroups);
                    dispatch(onHarmonyInit(tokenResult.enrollmentTokenId));
                } catch {
                    dispatch(onHarmonyInit(null));
                }
            }
        } else { //no harmony product group set as inited
            dispatch(afterHarmonyInit());
        }
    };
}

export function afterHarmonyInit() {
    return {
        type: HarmonyActionType.AFTER_INIT
    } as const;
}

export function fetchingToken() {
    return {
        type: HarmonyActionType.FETCHING
    } as const;
}

export function onHarmonyInit(tokenId: Nullable<string>) {
    return {
        type: HarmonyActionType.ON_INIT,
        payload: tokenId
    } as const;
}